import { useLayoutEffect, RefObject } from "react";
import { acquireNativeScrollGuard } from "./nativeScrollGuard";

/** Keep the installed WebView's pull-to-refresh outside the chat's scroll area. */
export function useTicketViewport(pageRef: RefObject<HTMLDivElement | null>): void {
    useLayoutEffect(() => {
        const page = pageRef.current;
        if (!page) return;

        const viewport = window.visualViewport;
        const releaseGuard = acquireNativeScrollGuard();
        let lastHeight = 0;
        const updateHeight = () => {
            const height = Math.round(viewport?.height ?? window.innerHeight);
            if (height !== lastHeight) {
                page.style.setProperty("--ticket-chat-viewport-height", `${height}px`);
                lastHeight = height;
            }
        };
        updateHeight();
        window.addEventListener("resize", updateHeight);
        viewport?.addEventListener("resize", updateHeight);

        return () => {
            window.removeEventListener("resize", updateHeight);
            viewport?.removeEventListener("resize", updateHeight);
            page.style.removeProperty("--ticket-chat-viewport-height");
            releaseGuard();
        };
    }, [pageRef]);
}
